import {ExtraModel} from './extra.model';
import {ExtraBasketModel} from './extra.basket.model';
import {ExtraBasketSessionModel} from './extra.basket-session.model';

export const createExtra = (payload: any): ExtraModel => {
  return {
    extraId: payload.extraId,
    rateId: payload.rateId,
    productId: payload.productId,
    offerId: payload.offerId,
    name: payload.name,
    isMandatory: payload.isMandatory,
    isPreselected: payload.isPreselected,
    summary: payload.description.summary,
    pictures: payload.description.pictures,
    counting: payload.description.counting,
    type: payload.description.type,
    gratuitousnessType: payload.gratuitousnessType,
    price: payload.price,
    taxes: payload.taxes,
    items: payload.items,
    sortOrder: payload.sortOrder,
  };
};

export const createExtraBasket = (payload: any): ExtraBasketModel => {
  return {
    extraId: payload.extraId,
    productId: payload.productId,
    offerId: payload.offerId,
    name: payload.name,
    availableQuantity: payload.availableQuantity,
    selectedQuantity: payload.selectedQuantity,
    price: payload.price,
    unitPrice: payload.unitPrice,
    class: payload.description.class,
    countingType: payload.description.countingType,
    gratuitousnessType: payload.description.gratuitousnessType,
    isMandatory: payload.description.isMandatory,
    isPreselected: payload.description.isPreselected,
    maximumQuantity: payload.description.maximumQuantity,
    occupancyDefinition: payload.description.occupancyDefinition,
    payOnline: payload.description.payOnline,
    pictures: payload.description.pictures,
    sortOrder: payload.description.sortOrder,
    stock: payload.description.stock,
    summary: payload.description.summary,
    type: payload.description.type,
  };
};

export const createExtraBasketSession = (payload: any): ExtraBasketSessionModel => {
  return {
    extraId: payload.extraId,
    originalPriceAtSelection: payload.originalPriceAtSelection,
    quantity: payload.quantity
  };
};
